var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-edition-section-content-subject"},[_vm._m(0),_c('p',[_c('router-link',{staticClass:"text-color-academy-primary",attrs:{"to":"/"}},[_vm._v("\n      Volver a listado de Mis Cursos.\n    ")])],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"margin-top-zero"},[_c('span',[_vm._v("Aún no tienes contenidos activos para este curso.")])])
}]

export { render, staticRenderFns }